import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTIONS } from './states';
export var reducer = function reducer(pluginState, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_PLUGIN_STATE:
      return _objectSpread(_objectSpread({}, pluginState), action.data);
    case ACTIONS.TOGGLE_PROACTIVE_ENABLED:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        toggleCount: action.data.toggleCount,
        isProactiveEnabled: !pluginState.isProactiveEnabled
      }, pluginState.isProactiveEnabled && {
        docChangeCountUntilLimit: 0
      });
    case ACTIONS.TOGGLE_PROACTIVE_CONTEXT_PANEL:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        isProactiveContextPanelOpen: !pluginState.isProactiveContextPanelOpen
      });
    // XXX: Chunks are no longer purged we we don't need the code for disabling the checker for those chunks
    // However I'm going to leave this here just in case we need to bring it back
    // case ACTIONS.DISABLE_NEED_SPELLING_AND_GRAMMAR:
    // 	return {
    // 		...pluginState,
    // 		proactiveAIBlocks: pluginState.proactiveAIBlocks?.map((block) => {
    // 			if (action.data.skippedChunkIds.includes(block.id)) {
    // 				return {
    // 					...block,
    // 					invalidated: false,
    // 					invalidatedForDocChecker: false,
    // 				};
    // 			}
    // 			return block;
    // 		}),
    // 	};
    // XXX: The new endpoint doesn't supply any metadata.
    // case ACTIONS.UPDATE_CHUNK_METADATA:
    // 	return {
    // 		...pluginState,
    // 		proactiveAIBlocks: pluginState.proactiveAIBlocks?.map((block) => {
    // 			if (action.data.chunkId === block.id) {
    // 				return {
    // 					...block,
    //					metadata: action.data.metadata,
    // 				};
    // 			}
    // 			return block;
    // 		}),
    // 	};
    // case ACTIONS.START_PROACTIVE_AI:
    // 	return {
    // 		...pluginState,
    // 		isProactiveEnabled: true,
    // 		toggleCount: pluginState.isProactiveEnabled
    // 			? pluginState.toggleCount
    // 			: pluginState.toggleCount + 1,
    // 	};
    default:
      return pluginState;
  }
};